import i18n from "../../i18n"

const listPermissions = [
  {
    id: "users-read",
    name: i18n.t("UserList"),
    value: "users::read"
  },
  {
    id: "users-write",
    name: i18n.t("UserEdit"),
    value: "users::write"
  },
  {
    id: "users-delete",
    name: i18n.t("UserDelete"),
    value: "users::delete"
  },
  {
    id: "users-create",
    name: i18n.t("UserCreate"),
    value: "users::create"
  },
  {
    id: "users-roles-read",
    name: i18n.t("UserRolesList"),
    value: "users::roles:read"
  },
  {
    id: "employees-write",
    name: i18n.t("UserRolesEdit"),
    value: "employees::write"
  },
  {
    id: "employees-create",
    name: i18n.t("EmployeesCreate"),
    value: "employees::create"
  },
  {
    id: "employees-delete",
    name: i18n.t("EmployeesDelete"),
    value: "employees::delete"
  },
  {
    id: "employees-read",
    name: i18n.t("EmployeesList"),
    value: "employees::read"
  },
  {
    id: "users-roles-write",
    name: i18n.t("EmployeesEdit"),
    value: "users::roles:write"
  },
  {
    id: "cost_center-read",
    name: i18n.t("CostCenterList"),
    value: "cost_center::read"
  },
  {
    id: "cost_center-write",
    name: i18n.t("CostCenterEdit"),
    value: "cost_center::write"
  },
  {
    id: "cost_center-delete",
    name: i18n.t("CostCenterDelete"),
    value: "cost_center::delete"
  },
  {
    id: "cost_center-create",
    name: i18n.t("CostCenterCreate"),
    value: "cost_center::create"
  },
  {
    id: "cost_center-employees-write",
    name: i18n.t("CostCenterEmployeesEdit"),
    value: "cost_center:employees::write"
  },
  {
    id: "cost_center-employees-delete",
    name: i18n.t("CostCenterEmployeesDelete"),
    value: "cost_center:employees::delete"
  },
  {
    id: "services-write",
    name: i18n.t("ServicesWrite"),
    value: "services::write"
  },
  {
    id: "services-delete",
    name: i18n.t("ServicesDelete"),
    value: "services::delete"
  },
  {
    id: "services-create",
    name: i18n.t("ServicesCreate"),
    value: "services::create"
  },
  {
    id: "services-driver-write",
    name: i18n.t("ServicesDriverWrite"),
    value: "services:driver::write"
  },
  {
    id: "services-driver-delete",
    name: i18n.t("ServicesDriverDelete"),
    value: "services:driver::delete"
  },
  {
    id: "services-driver-read",
    name: i18n.t("ServicesDriverList"),
    value: "services:driver::read"
  },
  {
    id: "control_tower-services-read",
    name: i18n.t("ControlTowerServicesList"),
    value: "control_tower:services::read"
  },
  {
    id: "comms-user-chat-write",
    name: i18n.t("CommsUserChatWrite"),
    value: "comms:user:chat::write"
  },
  {
    id: "comms-user-chat-read",
    name: i18n.t("CommsUseChatList"),
    value: "comms:user:chat::read"
  },
  {
    id: "comms-groups-chat-read",
    name: i18n.t("CommsGroupsChatList"),
    value: "comms:groups:chat::read"
  },
  {
    id: "comms-groups-chat-write",
    name: i18n.t("CommsGroupsChatEdit"),
    value: "comms:groups:chat::write"
  }
]

export { listPermissions }